<template>
    <p-modal
        name="ConfigureMadeToOrder"
        label="Configure Made To Order"
        size="xl"
        no-close-on-backdrop
        no-close-esc
        ok-only
        ok-title="Close"
    >
        <template v-slot:default>
            <div class="container-fluid">
                <span style="margin-top: -20px">
                    <p-button 
                      style="margin-bottom: 10px; 
                      margin-top: -10px;" 
                      variant="primary" 
                      @click="addNewGroup"
                      v-b-modal.editGroupModal>
                        <span class="d-inline-flex align-items-center">
                            <b-icon-plus class="me-1"></b-icon-plus>Create New Group
                        </span>
                    </p-button>
                </span>
                <b-row>
                    <div class="scrollable-container">
                        <draggable v-model="quickMenuItem.madeToOrderPrompts" :onMove="onMove" group="groups" item-key="madeToOrderPromptId">
                            <template #item="{ element: group, index }">
                                <div class="mb-2 me-2 border rounded">
                                    <b-row class="top-row justify-content">
                                      <b-col cols="auto">
                                          <div class="float-start icon-wrapper" @click.stop="toggleGroup(index)">
                                            <i :class="collapsedGroups[index] ? 'fas fa-caret-right caret-icon' : 'fas fa-caret-down caret-icon'"></i>
                                          </div>
                                      </b-col>
                                      <b-col cols="auto">
                                        <p-button @click="editGroup(group)" v-b-modal.editGroupModal>Edit Group</p-button>
                                        <p-button style="margin-left: 10px" @click="addItem(group)" v-b-modal.addItemModal>
                                              <span class="d-inline-flex align-items-center">
                                                  <b-icon-plus class="me-1"></b-icon-plus>Add Item
                                              </span>
                                            </p-button>
                                      </b-col>
                                      <b-col class="flex-grow-1">
                                        <span class="group-prompt">{{ group.prompt }}</span>
                                      </b-col>
                                    </b-row>
                                    <b-row style="margin-left: 5px; margin-right: 5px;display: flex;" v-show="!collapsedGroups[index]">
                                      <b-col>
                                      <draggable v-model="group.madeToOrderOptions" class="drag-container" handle=".drag-handle" group="items" item-key="madeToOrderOptionId">
                                        <template #item="{ element: item }">
                                          <div class="drag-item mb-2 drag-handle">
                                             <div class="clickable-box">
                                                <span class="text-content" @click.stop="editItem(item, group)" v-b-modal.editItemModal>{{ item.buttonText }}</span>
                                              </div>
                                          </div>
                                        </template>
                                      </draggable>
                                      </b-col>
                                    </b-row>
                                </div>
                            </template>
                        </draggable>
                    </div>

                    <!-- Edit Group Modal -->
                    <p-modal v-if="currentGroup" 
                        name="editGroupModal" 
                        label="Edit Group" 
                        @ok="saveGroup()"
                        @cancel="cancelEditGroup()"
                        @close="cancelEditGroup()" 
                        no-close-on-backdrop
                        no-close-esc>
                          <p-input v-model="currentGroup.prompt" label="Group Name"/>
                          <p-checkbox label="Required" v-model="currentGroup.isRequired" />
                          <p-checkbox label="Allow Multiple Selections" v-model="currentGroup.allowManySelections" />
                          <template v-slot:modal-footer="{ ok, cancel }">
                            <p-button v-if="!currentGroup.isNew" variant="outline-danger" @click="removeGroup()">Delete Group</p-button>
                            <p-button variant="outline-primary" @click="cancel">Cancel</p-button>
                            <p-button variant="primary" @click="ok">Ok</p-button>                           
                          </template>
                    </p-modal>

                    <!-- Edit Item Modal -->
                    <p-modal 
                        v-if="currentItem" 
                        name="editItemModal" 
                        label="Edit Item" 
                        @ok="saveItem()"
                        @cancel="cancelAddEditItem(true)"
                        @close="cancelAddEditItem(true)"
                        no-close-on-backdrop
                        no-close-esc>
                          <p-input v-model="currentItem.buttonText" label="Button Text" />
                          <p-input v-model="currentItem.containerName" label="Name" disabled />
                          <p-input v-model="currentItem.sku" label="Sku" disabled />
                          <p-number v-model="currentItem.price" left-align input-type="money" label="Price" :disabled="true" />
                          <template v-slot:modal-footer="{ ok, cancel }">
                            <p-button variant="outline-danger" @click="removeItem()">Remove Item</p-button>
                            <p-button variant="outline-primary" @click="cancel">Cancel</p-button>
                            <p-button variant="primary" @click="ok">Ok</p-button>                           
                          </template>
                    </p-modal>

                    <!-- Add Item Modal -->
                    <p-modal 
                        v-if="currentItem" 
                        size="xl"
                        name="addItemModal" 
                        label="Add Item" 
                        ok-title="Add"
                        @ok="saveItem()"
                        @cancel="cancelAddEditItem()"
                        @close="cancelAddEditItem()"
                        no-close-on-backdrop
                        no-close-esc>
                          <b-row>                            
                            <b-col>
                                  <!-- maybe we use a p-search-table here? -->
                                   <!-- gotta do the search thing and selecting/associating the chosen item -->
                                    <!-- admin tool has "winprism" and "360" add options. winprism searches special items/sku'd items. 360 you just put a name in-->
                              <ProductDraggableSearch
                                  place-holder="Search by Sku, Description"
                                  end-point="/quickmenus/searchproducts"
                                  style="height:560px;"
                                  disable-drag
                                  @item-selected="onItemSelected"
                                  >
                                      <template v-slot:headerRow>
                                          <b-row style="width: 620px">
                                              <b-col style="width: 225px;">
                                                  <h4>Description</h4>
                                              </b-col>
                                              <b-col cols="auto" class="ms-auto" style="width: 65px;">
                                                  <h4>Sku</h4>
                                              </b-col>
                                              <b-col cols="auto" class="ms-auto" style="text-align: right; margin-right: 45px; width: 100px">
                                                  <h4>Price</h4>
                                              </b-col>
                                          </b-row>
                                      </template>
                                      <template v-slot:itemText="{ value, item }">
                                          <b-row class="ps-1" :item="item"> <!-- this :item property is used for passing the item to the draggable component-->
                                              <b-col class="text-truncate" style="width: 425px;">{{ item.containerName }}</b-col>
                                              <b-col cols="auto" class="ms-auto" style="width: 95px;">{{ item.sku }}</b-col> 
                                              <b-col cols="auto" class="ms-auto" style="width: 95px;">{{ currencyFormatter(item.price) }}</b-col>
                                          </b-row>
                                      </template>
                                </ProductDraggableSearch>
                            </b-col>
                            <b-col>
                              <p-input v-model="currentItem.buttonText" label="Button Text" :disabled="!currentItem.containerName" />
                              <p-input v-model="currentItem.containerName" label="Name" disabled />
                              <p-input v-model="currentItem.sku" label="Sku" disabled />
                              <p-number v-model="currentItem.price" left-align input-type="money"  label="Price" :disabled="true" />
                            </b-col>
                          </b-row>
                    </p-modal>
                </b-row>
            </div>
        </template>
    </p-modal>
</template>

<script>
import ProductDraggableSearch from '@/components/ProductDraggableSearch.vue';
import { currencyFormatter } from '@/components/Common/Formatters.js';
import draggable from 'vuedraggable';

export default {
    name: "ConfigureMadeToOrder",
    props: {
        modelValue: Object
    },
    emits: ['update:modelValue', 'input'],
    components: { draggable, ProductDraggableSearch },
    watch: {
      modelValue: {
            handler: function(newVal) {
                this.quickMenuItem = newVal;
                this.$emit('update:modelValue', this.quickMenuItem);
            }
        }
    },
  data() {
    return {
      quickMenuItem: Object,
      backupmadeToOrderPrompts: Object,
      currentGroup: Object,
      currentItem: Object,
      backupItem: Object,
      backupGroup: Object,
      collapsedGroups: {},
    };
  },
  mounted(){
    this.quickMenuItem = this.modelValue;
    this.backupmadeToOrderPrompts = this.quickMenuItem?.madeToOrderPrompts;
  },
  methods: {
    currencyFormatter: currencyFormatter,
    toggleGroup(index){
      this.collapsedGroups[index] = !this.collapsedGroups[index];
    },
    onMove()
    {
      return true;
    },    
    addItem(group) {
      this.currentGroup = group;
      this.backupGroup = JSON.parse(JSON.stringify(group));
      this.currentItem = { 
          id: Date.now(), 
          name: '', 
          isNew: true };
    },    
    editItem(item, group) {
      this.currentItem = item;
      this.currentGroup = group;
      this.backupItem = JSON.parse(JSON.stringify(item));
    },
    saveItem()
    {
      if(this.currentItem.isNew)
      {
        this.currentItem.isNew = false;
        this.currentGroup.madeToOrderOptions.push(this.currentItem);
      }
      this.$bvModal.hide("addItemModal");
    },
    removeItem()
    {
      //add warnings
      let index = this.currentGroup.madeToOrderOptions.indexOf(this.currentItem);
      if(index !== -1)
      {
        this.currentGroup.madeToOrderOptions.splice(index,1);
      }
      this.$bvModal.hide("editItemModal");
    },
    cancelAddEditItem(isEdit)
    {
      Object.assign(this.currentItem, this.backupItem);
      if(isEdit)
      {
        this.$bvModal.hide("editItemModal");
      }
      else
      { 
        this.$bvModal.hide("addItemModal");
      }      
    },
    addNewGroup() {
      this.currentGroup = {
          isNew: true,
          id: Date.now(),
          prompt: `New Group`,
          madeToOrderOptions: []  
        };
      this.backupGroup = null;
    },
    editGroup(group) {
      this.currentGroup = group;
      this.backupGroup = JSON.parse(JSON.stringify(group));
      this.backupmadeToOrderPrompts = JSON.parse(JSON.stringify(this.quickMenuItem.madeToOrderPrompts));
    },
    cancelEditGroup()
    {
      Object.assign(this.currentGroup, this.backupGroup);
      Object.assign(this.quickMenuItem.madeToOrderPrompts, this.backupmadeToOrderPrompts)
      this.$bvModal.hide("editGroupModal");
    },    
    saveGroup()
    {
      if(this.currentGroup.isNew)
      {
        this.currentGroup.isNew = false;
        this.quickMenuItem.madeToOrderPrompts.push(this.currentGroup);
      }
      this.$bvModal.hide("editGroupModal");
    },
    removeGroup()
    {
      //add warnings
      var index = this.quickMenuItem.madeToOrderPrompts.indexOf(this.currentGroup);
      if(index !== -1)
      {
        this.quickMenuItem.madeToOrderPrompts.splice(index,1);
      }
      this.$bvModal.hide("editGroupModal");
    },
    onItemSelected(item)
    {
      this.currentItem = {
              ...item,
              buttonText: item.containerName,
              isNew: true
            };
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/app/common/variables.scss";
:deep(.custom-colors .btn-secondary) {
  background-color: #f0f0f0; 
  color: #4D778C;
}

.icon-wrapper {
  width: 1.5em;
  display: inline-block;
  text-align: center;
}

:deep(.modal-dialog ) {
  height: 90vh !important;
}

:deep(.modal-content ) {
  height: 100% !important;
}

:deep(.modal-body ) {
  height: 85% !important;
}

.clickable-box {
  width: 125px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px #4D778C;
  background: linear-gradient(#f0f0f073, #d3dadd);
  border-radius: 5px;
  color: #4D778C;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  float: left;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  line-height: 1.25em;
  transition: all 0.3s ease;
}

.text-content {
  width: 110px;
  height: 50px;
  justify-content: center;
  align-items: center;
  font-size: 14px;  
  white-space: normal;
  font-weight: bold;
  display: flex;
}

.clickable-box:hover {
  background: linear-gradient(#d3dadd, #f0f0f073); 
  border-color: #3E5B6E; 
  color: #3E5B6E; 
}

.clickable-box:active {
  background: linear-gradient(#a3b1b8, #c1cdd8); 
  border-color: #2c3e50; 
  color: #2c3e50; 
}

.top-row {
    background-color: #4D778C; 
    padding: 0;  
    margin: 0;  
    height: 45px;
    display: flex;
    align-items: center;
    border-radius: 5px 5px 0 0;
    margin-bottom:10px;
    padding-top: 3px;
    padding-bottom: 3px;
}

.scrollable-container {
  height: 72vh;
  overflow-y: auto;
  overflow-x: hidden;
  flex-wrap: wrap;
  width: 100%;
}

.empty-placeholder {
  text-align: center;
  color: #aaa;
  font-style: italic;
  padding: 20px 0;
}

.group-prompt {
  font-size: 1.5rem;
  font-weight: bold;
  margin-right: 10px;
  display: inline-block;
  color: #f0f0f0;
}

.drag-container {
  display: inline-flex;
  flex-direction: row;
  list-style: none;
  padding: 0;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.drag-item {
  margin-right: 5px;
  cursor: move;
}

.caret-icon{
  font-size: 1.6em;
  margin-top: 3px;
  color: #f0f0f0;
}
</style>